function mute(regions, ismute = true, isSeries = false) {
  regions.selectAll(isSeries ? this.seriesName() : this.nodeName()).classed('mute', ismute).call(ismute ? this.mute : this.demute, this.muteIntensity());
}
function filter(callback, selection) {
  let cond;
  if (typeof callback === 'function') { cond = callback }
  else if (typeof callback === 'string') {
   cond = function(d) { return d.data.key !== callback; };
  } else if (typeof callback === 'object' && callback.data) {
   cond = function(d) { return d.data.key !== callback.data.key; };
  }
  if (cond) {
    if (selection) return selection.filter(cond);
    return this.filterRegions(cond, true); //.facet region은 포함하지 않는다.
  }
  return null;
}
function muteRegions(callback) {
  let regions;
  if (!arguments.length) { //모두 
    regions = this.filterRegions();
    mute.call(this, regions, true);
    if (this.seriesName) mute.call(this, regions, true, true);
  } else if (callback === null) { //모두 끄기
    regions = this.filterRegions();
    mute.call(this, regions, false);
    if (this.seriesName) mute.call(this, regions, false, true);
  } else {
    regions = filter.call(this, callback);
    if (regions.size() > 0) {
      mute.call(this, regions, true);
      if (this.seriesName) mute.call(this, regions, true, true);
    }
  } 
  return this;
}

export default muteRegions;
export {filter};


// WEBPACK FOOTER //
// ./layouts/default/muteRegions.js